import { useFetch } from '../../../hooks/useFetch';
import { Biometric } from '../../../models/biometric';
import { errorNotification } from '../../../providers/mantine-notifications';
import { translateServerHttpErrors } from '../../../utils/helpers';
import {
  UseDeleteUserBiometricProps,
  UseListUserBiometricProps,
} from '../../../utils/types/data/hooks/biometric';
import { deleteUserBiometric, listBiometricByUser } from '../../biometric';

export function useListUserBiometric() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<Biometric[]>();

  const fetch = ({ id, onSuccess }: UseListUserBiometricProps) =>
    fetchData({
      fetcher: () => listBiometricByUser(id),
      onError: async (error: any) => {
        errorNotification({
          title: 'Erro buscar biometrias.',
          message: translateServerHttpErrors(error, 'Tente novamente'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

export function useDeleteUserBiometric() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<void>();

  const fetch = ({ id, onSuccess }: UseDeleteUserBiometricProps) =>
    fetchData({
      fetcher: () => deleteUserBiometric(id),
      onError: async () => {
        errorNotification({
          title: 'Erro excluir biometria.',
          message: 'Tente novamente',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}
